import { render, staticRenderFns } from "./NavDrawerBase.vue?vue&type=template&id=4f2685fa&scoped=true&"
import script from "./NavDrawerBase.vue?vue&type=script&lang=js&"
export * from "./NavDrawerBase.vue?vue&type=script&lang=js&"
import style0 from "./NavDrawerBase.vue?vue&type=style&index=0&id=4f2685fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2685fa",
  null
  
)

export default component.exports